import React from 'react'
import PropTypes from 'prop-types'
import { Card } from 'material-ui/Card'

import styles from './styles.css'

const ApptTypesCard = ({
  appointmentType: { code, description, id, post_nv_window: window },
  isCloseable,
  patchAppointmentType,
}) => {
  const apptTypesCardStyles = {
    display: 'inline-block',
    position: 'relative',
    background: '#ececec',
    padding: '10px 20px 0',
    paddingRight: isCloseable ? '50px' : '20px',
  }
  return (
    <div className={styles.apptTypesCard}>
      <Card expandable={false} containerStyle={apptTypesCardStyles}>
        <h4>{code}</h4>
        <p>{description}</p>
        {isCloseable && (
          <div
            role="button"
            tabIndex="0"
            className={styles.apptTypesClose}
            onClick={() => patchAppointmentType(id, 'existing', window)}
          />
        )}
      </Card>
    </div>
  )
}

ApptTypesCard.propTypes = {
  appointmentType: PropTypes.shape({
    code: PropTypes.string,
    description: PropTypes.string,
    id: PropTypes.string,
    window: PropTypes.number,
  }),
  isCloseable: PropTypes.bool,
  patchAppointmentType: PropTypes.func,
}

export default ApptTypesCard



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/AppointmentTypes/ApptTypesCard.js